<template>
  <nav>
    <v-row class="fill-height" align="center">
      <v-col cols="12" sm="8" md="6" offset-sm="2" offset-md="3" align="center">
        <AlertMessages
          v-if="alertValue"
          :alert-type="alertType"
          :alert-msg="alertMsg"
          @reset="alertValue = false"
        />
        <v-card max-width="800" elevation="0" rounded="xxl" color="background">
          <v-card-title
            class="text-h5 font-weight-bold text-center justify-center mb-4 no-break"
          >
            {{ $t("attachCustomerTitle") }}
          </v-card-title>
          <v-form ref="form" v-model="valid" @submit.prevent>
            <v-card-subtitle class="text-body-2 greytext--text">
              {{ $t("attachCustomerFieldDescription") }}
            </v-card-subtitle>
            <v-autocomplete
              v-model="selectedUser"
              :menu-props="{
                closeOnContentClick: true,
                rounded: 'xxl',
                zIndex: '9999 !important',
              }"
              filled
              rounded
              deletable-chips
              clearable
              solo
              no-filter
              :search-input.sync="searchKeyword"
              :items="entries"
              :placeholder="$t('typeToSearch')"
              background-color="#fff"
              data-testid="store-customers-input"
              class="expanding-search text-body-2 mt-3"
              return-object
              :multiple="false"
              :readonly="selectedUser != null"
            >
              <template v-slot:no-data>
                <p class="mx-5 mt-4">
                  {{ $t("noDataText") }}
                </p>
              </template>
              <template v-slot:selection="data">
                <v-chip
                  v-if="data.item.type == 'store-customers'"
                  v-bind="data.attrs"
                  data-testid="user-chip"
                >
                  <v-avatar left>
                    <v-img
                      v-if="data.item.attributes.avatar_thumb == null"
                      src="../../assets/user_images/profile-avatar.png"
                    />
                    <v-img v-else :src="data.item.attributes.avatar_thumb" />
                  </v-avatar>
                  {{ data.item.attributes.first_name }}
                  {{ data.item.attributes.last_name }} -
                  {{ data.item.attributes.email }} -
                  {{ data.item.attributes.company_name }}
                </v-chip>
              </template>
              <template v-slot:item="data">
                <v-list-item-avatar
                  v-if="data.item.type == 'store-customers'"
                  rounded="lg"
                >
                  <img
                    v-if="data.item.attributes.avatar_thumb == null"
                    src="../../assets/user_images/profile-avatar.png"
                  />
                  <img v-else :src="data.item.attributes.avatar_thumb" />
                </v-list-item-avatar>
                <v-list-item-avatar v-else rounded="lg">
                  <img
                    v-if="data.item.attributes.avatar_thumb == null"
                    src="../../assets/user_images/target-group-avatar.png"
                  />
                </v-list-item-avatar>
                <v-list-item-content v-if="data.item.type == 'store-customers'">
                  <v-list-item-title
                    >{{
                      data.item.attributes.first_name +
                      " " +
                      data.item.attributes.last_name
                    }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ data.item.attributes.email }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    {{ data.item.attributes.company_name }}
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-content v-else>
                  <v-list-item-title>{{
                    data.item.attributes.name
                  }}</v-list-item-title>
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </v-form>
        </v-card>
        <v-row>
          <v-col align="center">
            <FormFooter
              next-button-text="add"
              :loading="loading"
              :cancel-button-link="cancelLink"
              @proceedSubmit="addToCustomer"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </nav>
</template>
<script>
import i18n from "../../plugins/i18n";
import { searchCustomer } from "../../api/productApi";
import { addToCustomer, getStoreOrder } from "../../api/productApi";
import FormFooter from "../../components/FormFooter";
import AlertMessages from "../../components/AlertMessages";
import _ from "lodash";

export default {
  components: {
    FormFooter,
    AlertMessages,
  },
  data() {
    return {
      spaceId: window.$cookies.get("space_id"),
      descriptionLimit: 60,
      selectedUser: null,
      entries: [],
      alertMsg: "",
      alertValue: false,
      loading: false,
      valid: true,
      orderId: this.$route.params.id,
      autocompleteRules: [
        (v) => {
          if (!v || v.length < 1) {
            return i18n.t("labelInputRequired");
          } else return true;
        },
      ],
      cancelLink: "/store/order/" + this.$route.params.id,
      previousRoute: null,
      storeOrder: {},
      searchKeyword: null,
    };
  },

  watch: {
    searchKeyword(val) {
      if (val == null || val == "") {
        this.entries = [];
        return;
      }
      let searchkey = val.trim();
      if (searchkey.length < 1) return;
      this.searchCustomer(searchkey);
    },
    selectedUser(val) {
      if (val == null || val == "") {
        this.entries = [];
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    if (from.path != null && from.path != "/redirect" && from.path != "/") {
      next((vm) => {
        (vm.cancelLink = from.path), (vm.previousRoute = from);
      });
    } else {
      next();
    }
  },
  methods: {
    async fetchStoreOrder() {
      try {
        const response = await getStoreOrder(this.orderId);
        if (response.status == 200) {
          this.storeOrder = response.data.data;
        }
      } catch (e) {
        if (e.response) {
          if (e.response.status == 404) {
            this.$router.push({ name: "PageNotFound" });
          } else if (e.response.status == 403) {
            this.$router.push({ name: "PageAccessDenied" });
          } else {
            this.alertValue = true;
            this.alertType = "error";
            this.alertMsg = i18n.t("serverError");
          }
        }
      }
    },
    async addToCustomer() {
      this.$refs.form.validate();
      await this.fetchStoreOrder();
      if (this.valid) {
        this.loading = true;
        try {
          let data = {
            data: {
              id: this.storeOrder.id,
              type: "store-orders",
              attributes: {
                first_name: this.storeOrder.attributes.first_name,
                last_name: this.storeOrder.attributes.last_name,
                email: this.storeOrder.attributes.email,
                company_name: this.storeOrder.attributes.company_name,
                organization_number:
                  this.storeOrder.attributes.organization_number,
                company_address: this.storeOrder.attributes.company_address,
                city: this.storeOrder.attributes.city,
                post_code: this.storeOrder.attributes.post_code,
                participants: this.storeOrder.attributes.participants,
              },
              relationships: {
                "store-customer": {
                  data: {
                    type: "store-customers",
                    id: this.selectedUser.id,
                  },
                },
                space: {
                  data: {
                    type: "spaces",
                    id: this.spaceId,
                  },
                },
                product: {
                  data: {
                    type: "store-products",
                    id: this.storeOrder.attributes.product.uuid,
                  },
                },
              },
            },
          };

          const response = await addToCustomer(this.storeOrder.id, data);

          if (response.status == 200) {
            this.$router.push({
              name: "ViewOrder",
              params: { id: this.orderId, successfullyAttachedCustomer: true },
            });
          }
        } catch (e) {
          if (e.response) {
            this.alertValue = true;
            if (e.response.status == 403) {
              this.$router.push({ name: "PageAccessDenied" });
            } else if (e.response.status == 404) {
              this.$router.push({ name: "PageNotFound" });
            } else {
              this.alertType = "error";
              this.alertMsg = i18n.t("serverError");
            }
          }
        }
        this.loading = false;
      }
    },

    searchCustomer: _.debounce(async function (keyword) {
      var searchCustomers = [];

      if (keyword && keyword.trim().length >= 1) {
        try {
          const response = await searchCustomer(this.spaceId, keyword);
          if (response) {
            if (response.status == 200) {
              searchCustomers = response.data.data;
            }
          }
        } catch (e) {
          if (e.response) {
            this.error = true;
            this.alertType = "error";
            this.alertMsg = i18n.t("serverError");
            this.alertValue = true;
          }
        }

        this.entries = searchCustomers;
      }
    }, 500),
  },
};
</script>